import { render } from "./DataDocumentResp.vue?vue&type=template&id=2e7c0e80"
import script from "./DataDocumentResp.vue?vue&type=script&lang=js"
export * from "./DataDocumentResp.vue?vue&type=script&lang=js"

import "./DataDocumentResp.vue?vue&type=style&index=0&id=2e7c0e80&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__